import { DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_ROLE, OPTIONS_STATUS_SELECTION } from '../../configData'
import { userSearch } from '../../services/cmsservice'
import openNotification from '../common/Notification/openNotification '
import { removeVietnameseTones } from '../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPostCategory = ({ form, handleSaveCategory }) => {

  return (
    <Form
      form={form}
      onFinish={handleSaveCategory}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Catergory"
        name="category"
        rules={[{ required: true, message: 'Vui lòng nhập category' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập category" />
      </Form.Item>
      <Form.Item
        label="Code"
        name="code"
        rules={[{ required: true, message: 'Vui lòng nhập code' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập code" />
      </Form.Item>
     
    </Form>
  )
}

export default FormPostCategory
